module.exports = __webpack_public_path__ + "static/media/Wespath_C.e2c79c73.png";